import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import General from "./modules/General"
import Auth from "./modules/Auth"
import Calendar from "./modules/Calendar"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    General,
    Auth,
    Calendar,
  },
  plugins: [createPersistedState()]
})
